import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getDashboardStore = (store: IStore) => store.dashboard;

export const getDashboardResult = createSelector([getDashboardStore], (store) => store.dashboard);
